@if (isEmptyForm) {
  <div class="form-container">
    <clickatell-expansion-panel>
      <ng-container header>
        <mat-panel-title>
          Parameters
        </mat-panel-title>
      </ng-container>
      <ng-container body>
        <ng-container [formGroup]="isEmptyForm">
          <div class="control-div">
            <div class="control-label-container">
              <label class="control-label"> Name </label>
            </div>
            <clickatell-form-validation [controlName]="'name'"
            [form]="isEmptyForm"></clickatell-form-validation>
            <input class="control-input" activeForm [activeForm]="isEmptyForm" id="name"
              [formControlName]="'name'" placeholder="Enter name"/>
            </div>
            <div class="control-div">
              <div class="control-label-container">
                <label class="control-label"> Description </label>
              </div>
              <clickatell-form-validation [controlName]="'description'"
              [form]="isEmptyForm"></clickatell-form-validation>
              <input class="control-input" activeForm [activeForm]="isEmptyForm" id="description"
                [formControlName]="'description'" placeholder="Enter description"/>
              </div>
              <div class="control-div">
                <div class="control-label-container">
                  <label class="control-label"> Variable Name </label>
                </div>
                <clickatell-form-validation [controlName]="'variableName'"
                [form]="isEmptyForm"></clickatell-form-validation>
                <input class="control-input" activeForm [activeForm]="isEmptyForm" id="variableName"
                  [formControlName]="'variableName'" placeholder="Enter variable name"/>
                </div>
              </ng-container>
            </ng-container>
          </clickatell-expansion-panel>
          <clickatell-expansion-panel>
            <ng-container header>
              <mat-panel-title>
                Logic
              </mat-panel-title>
            </ng-container>
            <ng-container body>
              <ng-container [formGroup]="isEmptyForm">
                <div class="control-result">
                  <div class="control-result-header">
                    Yes
                  </div>
                  <div class="control-result-container">
                    <div class="control-div">
                      <label class="control-label">
                        <span class="pont-to">Point To</span>
                        <app-cms class="popover" [type]="'nodeBuild'" [field]="'next'"></app-cms>
                      </label>
                      @if (nodeFlowDetails) {
                        <next-selector [canEditFlows]="canEdit.canEditFlows"
                          [selectorType]="'both'"
                          [flowSteps]="nodeFlowDetails.currentFlowSteps"
                          [flows]="nodeFlowDetails.flows"
                          [name]="'yes'"
                          [form]="isEmptyForm"
                          [stepId]="nodeFlowDetails.stepId">
                        </next-selector>
                      }
                    </div>
                  </div>
                </div>
                <div class="control-result">
                  <div class="control-result-header">
                    No
                  </div>
                  <div class="control-result-container">
                    <div class="control-div">
                      <label class="control-label">
                        <span class="pont-to">Point To</span>
                        <app-cms class="popover" [type]="'nodeBuild'" [field]="'next'"></app-cms>
                      </label>
                      @if (nodeFlowDetails) {
                        <next-selector [canEditFlows]="canEdit.canEditFlows"
                          [selectorType]="'both'"
                          [flowSteps]="nodeFlowDetails.currentFlowSteps"
                          [flows]="nodeFlowDetails.flows"
                          [name]="'no'"
                          [form]="isEmptyForm"
                          [stepId]="nodeFlowDetails.stepId">
                        </next-selector>
                      }
                    </div>
                  </div>
                </div>
              </ng-container>
            </ng-container>
          </clickatell-expansion-panel>
        </div>
      }